import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { AUTH_TOKEN, SIGNIN, GET_PERMISSIONS } from "../constants/Auth";
import {
  showAuthMessage,
  authenticated,
  storePermissionsAction,
} from "../actions/Auth";
import JwtAuthService from "services/JwtAuthService";

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const { email, password } = payload;
    try {
      const userService = yield call(JwtAuthService.login, { email, password });
      if (!userService.success) {
        yield put(showAuthMessage(userService.message, !userService.success));
      } else {
        localStorage.setItem(AUTH_TOKEN, userService.data.token);
        yield put(authenticated(userService.data.token));
        const permissions = yield call(JwtAuthService.permissions);
        yield put(storePermissionsAction(permissions.data));
        yield put(showAuthMessage(userService.message, !userService.success));
      }
    } catch (err) {
      yield put(showAuthMessage(err.message || "Error al iniciar sesión", true));
    }
  });
}

export function* getPermissions() {
  yield takeEvery(GET_PERMISSIONS, function* () {
    try {
      const permissionService = yield call(JwtAuthService.permissions);
      if (!permissionService.success) {
        yield put(
          showAuthMessage(permissionService.message, !permissionService.success)
        );
      } else {
        yield put(storePermissionsAction(permissionService.data));
        yield put(
          showAuthMessage(permissionService.message, !permissionService.success)
        );
      }
    } catch (err) {
      yield put(showAuthMessage(err.message || "Error al obtener permisos", true));
    }
  });
}

/* export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
    yield put(signOutSuccess());
  });
} */

export default function* rootSaga() {
  yield all([
    fork(signInWithFBEmail),
    fork(getPermissions),
    //fork(signOut),
  ]);
}
